import { daysBetween, parseISOToLocalDate } from '../../utils/dateUtils';

/** Live claim age in days (billing-period end → today), or null if no end date. */
export function claimAgeDays(periodEnd?: string | null): number | null {
  const end = parseISOToLocalDate(periodEnd ?? undefined);
  if (!end) return null;
  return Math.max(0, daysBetween(end, new Date()));
}

/** Frozen days-to-pay (billed → paid), or null if either date is missing/invalid. */
export function daysToPayDays(
  billedAt?: string | null,
  paidDate?: string | null
): number | null {
  if (!billedAt || !paidDate) return null;
  const billed = new Date(billedAt);
  const paid = new Date(paidDate);
  if (Number.isNaN(billed.getTime()) || Number.isNaN(paid.getTime()))
    return null;
  return daysBetween(billed, paid);
}
